import { render, staticRenderFns } from "./InventoryOverview.vue?vue&type=template&id=721d69d2&scoped=true&"
import script from "./InventoryOverview.vue?vue&type=script&lang=ts&"
export * from "./InventoryOverview.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryOverview.vue?vue&type=style&index=0&id=721d69d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721d69d2",
  null
  
)

export default component.exports